// utils/getHighlightStyle.js
export function GetHighlightStyle(field, scaleX, scaleY) {
    const { topRightX, topRightY, bottomLeftX, bottomLeftY } = field;
  
    const left = bottomLeftX * scaleX;
    const top = topRightY * scaleY;
    const width = (topRightX - bottomLeftX) * scaleX;
    const height = (bottomLeftY - topRightY) * scaleY;
  
    return {
      left,
      top,
      width,
      height,
    };
  }
  